import { ADVANTAGES_CONSTANTS } from "./constants";
import AdvantageCardList from "./card";

const AdvantageComp = () => {
  return <AdvantageCardList items={ADVANTAGES_CONSTANTS} />;
};

export default AdvantageComp;
